import { useState, useEffect } from "react";

export function useHeightOfProducts(props) {
  const [height, setHeight] = useState();
  useEffect(() => {
    let cancelled = false;
    const heightOfProducts = document.getElementById("products-grid-column");
    if (heightOfProducts) {
      const timer = setTimeout(() => {
        if (!cancelled) {
          setHeight(heightOfProducts.offsetHeight);
        }
      }, 500);
      return () => {
        cancelled = true;
        clearTimeout(timer);
      };
    }
  }, []);

  return height;
}
